import {useEffect, useRef} from 'react'
import {publish} from '@/script/event.mjs'
import TreeDoc from './TreeDoc.mjs'
import {useInstallPlugins} from './plugin.mjs'

export default ({
    Doc = TreeDoc,
    initData = {root: {}},
    plugins = [],
} = {}) => {
    const refDoc = useRef()
    refDoc.current ??= new Doc
    useInstallPlugins(refDoc.current, plugins)

    useEffect(
        () => {
            (async () => {
                const doc = refDoc.current
                await doc.init(initData?.root)
                publish(doc, 'init')
            })()
        },

        []
    )

    return refDoc.current
}
